import numeral from 'numeral';

export const formatDecimal = (decimal: number) => numeral(decimal).value().toString().replace('.', ',');